import React from "react"
import PropTypes from "prop-types"
import { MenuButton, MenuPopover, Menu, MenuItems } from "@reach/menu-button"
import CKIcon from "@convertkit/design/ck-icon"

const NavButton = ({ title, isExpanded }) => {
  const iconTransform = isExpanded && "transform -rotate-180"
  const activeButtonStyles = isExpanded
    ? "text-white active"
    : "text-gray-300 focus:text-white hover:text-white"

  return (
    <MenuButton
      className={`nav-hover rounded text-sm mr-1 font-semibold capitalize inline-flex items-center ${activeButtonStyles} duration-200 focus:outline-none text-kit-black hover:text-kit-black focus:text-kit-black focus:bg-blue-600 focus:bg-warm-white-200`}
      style={{ padding: "4px 4px 4px 12px" }}
    >
      {title}
      <CKIcon name="down" className={`${iconTransform}`} aria-hidden />
    </MenuButton>
  )
}

const NavSection = ({ children, title }) => {
  const colCount = length => {
    if (typeof length !== "number") return
    if (length >= 4) {
      return 2
    } else {
      return 1
    }
  }

  return (
    <Menu className="relative">
      {({ isExpanded }) => (
        <>
          <NavButton title={title} isExpanded={isExpanded} />

          <MenuPopover style={{ zIndex: 10000 }}>
            <MenuItems
              className="rounded shadow-lg main-menu-card text-gray-900 mt-2"
              style={{
                gridTemplateColumns: `repeat(${colCount(
                  children?.length
                )}, minmax(328px, 1fr))`
              }}
            >
              {children}
            </MenuItems>
          </MenuPopover>
        </>
      )}
    </Menu>
  )
}

NavSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
}

export default NavSection
